<script>
import Login from './Login.svelte';
import LoginEmailOnly from './LoginEmailOnly.svelte';
import { useLocation, useNavigate } from "svelte-navigator";
import { SignUpComponent } from './theme';

const location = useLocation();
const navigate = useNavigate();

const tabs = [
  {slug: '/signup', title: 'SIGN UP', component: SignUpComponent},
  {slug: '/signin', title: 'SIGN IN', component: Login}
]

let path;
$: path = $location.pathname;
$: activeTab = tabs.find(t => t.slug === path) || tabs[0]
</script>

<div class="box">
  <div class="tabs row">
    {#each tabs as tab}
      <div class="tab row hcenter vcenter" class:active={activeTab === tab} on:click={() => navigate(tab.slug, { replace: true })}>{tab.title}</div>
    {/each}
  </div>

  <div class="content col vcenter">
    <svelte:component this={activeTab.component} />
  </div>
</div>

<style lang="scss">
@import './util';
@import './login';
@import './theme';

.tabs {
  flex: 1;
}

.tab {
  flex: 1;
  height: 62px;
  background-color: $login-tab-inactive-background-color;
  color: $login-tab-inactive-foreground-color;
  font-size: 24px;
  font-weight: 800;
  font-family: $secondary-font;
  cursor: pointer;
  user-select: none;
}

.tab.active {
  background-color: $login-tab-active-background-color;
  color: $login-tab-active-foreground-color;
}
</style>